import { Save, Type } from "lucide-react";

export default function AdminHeadersEditor({ readOnly = false, sectionHeaders, setSectionHeaders, saving, handleSaveSectionHeaders }) {
  return (
    <fieldset data-id="admin-headers" disabled={readOnly} className="animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="bg-white border border-fendi p-8 max-w-4xl shadow-sm">
        <p className="eyebrow mb-8 flex items-center gap-2 text-champagne"><Type size={16} /> Títulos e Chamadas de Secção</p>
        <p className="text-sm text-warmgray text-center py-10">Os cabeçalhos de secção foram movidos para os respetivos menus (Serviços, Portfólio, Depoimentos, FAQ, Contacto).</p>
        </div>
      </fieldset>
  );
}
